import Colors from "../../../theme/colors";

const Styles = {
  tableRow: {
    "& > *": { borderBottom: "unset" },
    background: "#F2F2F2",
    border: "1px solid #DADADA",
    p: 1,
  },
  left: {
    display: "flex",
    alignItems: "center",
    // width: "40%",
  },

  right: {
    display: "flex",
    justifyContent: "end",
    width: "85%",
  },

  tableHeadCell: {
    p: 1,
    fontSize: 10,
    borderBottom: "none",
    color: "#0000ff",
    paddingBottom: 0,
  },

  tableBodyCell: {
    p: 1,
    fontSize: 10,
    borderBottom: "none",
    paddingTop: 0,
  },

  tableRowSecondary: {
    p: 1,
    fontSize: 10,
    borderBottom: "none",
    paddingTop: 0,
    display: "flex",
  },

  buttonStyle: {
    fontSize: 10,
    border: "1px solid crimson",
    borderRadius: "10px",
    color: "#616161",
    padding: "0 10px",
  },

  linkStyle: {
    textDecoration: "none",
    color: "#616161",
  },

  typography: {
    fontSize: "28px",
    fontWeight: "400",
  },

  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },

  noDataMsg: {
    color: "red",
  },
};

export const tableStyles = {
  container: {
    backgroundColor: Colors.white,
    borderRadius: "8px",
    height: "100",
  },
  search: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  searchInput: {
    width: "50%",
    border: "none",
  },
  tableContainer: {
    marginTop: "3rem",
  },
  tableTitle: {
    color: Colors.mediumBlack,
    fontSize: "1.2rem",
    fontWeight: 500,
  },
  tableInfo: {
    fontSize: "1rem",
  },
  export: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    marginBottom: "0.5rem",
  },
  tableHeading: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
  },
  subTitle: {
    fontWeight: "400",
    fontSize: "8px",
    lineHeight: "20px",
    color: "#171B5E",
  },
  infoLabel: {
    px: "16px",
    py: "4px",
    mr: "12px",
    background: "#F2F2F2",
    borderRadius: "3px",
  },
  TableTitle: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "21px",
    color: "#616161",
    mb: "10px",
    mt: "23px",
  },
  doubleArrow: {
    backgroundColor: "#CDCBCD",
    width: "30px",
    height: "30px",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFF",
    mx: "6px",
  },
  singleArrow: {
    backgroundColor: "#171B5E",
    width: "30px",
    height: "30px",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFF",
    mx: "6px",
  },
  actionBtn: {
    borderRadius: 0,
    fontSize: 12,
    color: "#FB5C5F",
    backgroundColor: "rgb(242, 242, 242)",
    padding: "2px 8px",
  },
  actionButtons: {
    display: "flex",
    gap: 22,
    justifyContent: "center",
  },
  actionIcon: {
    cursor: "pointer",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  left: {
    display: "flex",
    gap: "1rem",
  },

  tableCell: {
    textAlign: "center",
  },
};

export const formStyles = {
  typography: {
    color: "#1F26C7",
    marginBottom: 25,
    fontSize: 16,
    fontWeight: 500,
  },

  //   gridStyle: {
  //     marginTop: 15,
  //     marginBottom: 15,
  //   },

  typographySecondary: {
    marginTop: 20,
    marginBottom: 20,
  },

  inputField: {
    width: "275px",
  },
  gridContainerStyle: {
    marginTop: 8,
  },
  gridStyle: {
    marginTop: 12,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "1.5rem",
  },
  borderStyle: {
    borderTop: "1px solid #707070",
    paddingTop: "12px",
    marginTop: "-5px",
    width: "300px",
  },
  cancelBtnStyle: {
    marginTop: 5,

    marginLeft: "10px",
  },
  inputStyle: {
    height: 109,
    minWidth: 340,
    maxWidth: 460,
    marginLeft: "15px",
    // border: "1px solid #707070",
    borderRadius: "5px",
  },
};

export default Styles;
